export default __webpack_public_path__ + "static/media/exclusive2.b3034f3a.png";